module.exports = __webpack_public_path__ + "static/media/dark-bulletin.37e26796.svg";